/**
 * Base api path
 *
 * @type {string}
 */

export const debugMode = true;

// export const apiPath = 'https://lsc-api.app';
// export const clientSecret = '3C4TAh8xQyhWUlb1B08jyQdBQXW1CERO9rRG4s8N';
// export const publicStreamPath = 'https://edge-staging.livestormchasing.com'
export const apiPath = 'https://api.livestormchasing.com';
export const sitePath = 'https://api.livestormchasing.com/';
export const clientSecret = '3C4TAh8xQyhWUlb1B08jyQdBQXW1CERO9rRG4s8N';
export const publicStreamPath = 'https://edge.livestormchasing.com';

